export const analyticsLink =  "/analytics";